// src/data/dropdownOptions.ts

import { DropdownOptions, DSPSubgenreMap } from "../types/dropdownTypes";

export const dspDropdownOptions: DropdownOptions = {
  configuration: ["Song", "Album", "EP", "Waterfall", "Mixtape", "Video", "Audiobook"],

  musicCulture: [
    "African",
    "Arabic",
    "Buddhist",
    "Caribbean",
    "Celtic",
    "Christian",
    "Hindu",
    "Indigenous",
    "Islamic",
    "Judaic",
    "Latin",
    "Sikh",
    "South African",
    "None Of These",
  ],

  instruments: [
    "Accordion",
    "Acoustic Guitar",
    "Banjo",
    "Bass Guitar",
    "Buzuq",
    "Cello",
    "Drum Kit",
    "Electric Guitar",
    "Erhu",
    "Fiddle",
    "Flute",
    "Harmonica",
    "Harp",
    "Kora",
    "Mandolin",
    "Mbira",
    "Oboe",
    "Organ",
    "Oud",
    "Pedal Street Guitar",
    "Piano",
    "Samples",
    "Sanxian",
    "Sarod",
    "Sitar",
    "Steel Drum",
    "Synthesizer",
    "Tabla",
    "Trombone",
    "Trumpet",
    "Ukelele",
    "Violin",
    "Xylophone",
  ],

  songStyle: [
    "Acoustic",
    "Ballad",
    "Beats",
    "Christmas",
    "Experimental",
    "Goth",
    "Holiday",
    "Kids",
    "Traditional",
    "None of these",
  ],

  priority: [
    "High Priority",
    "Priority",
    "Genre Priority",
    "Low Genre Priority",
    "Standard Release",
  ],

  deezerEditorialTeam: [
    "GLOBAL",
    "FR",
    "BRA",
    "SP",
    "MX",
    "PT",
    "IT",
    "JP",
    "UK",
    "BENELUX",
    "DE",
    "CL",
  ],

  deezerPlaylists: {
    "Rap & Hip-Hop": [
      "Rap Bangers",
      "Fresh Rap",
      "Baddie Mode",
      "Drill Scenes",
      "Hip Hop Hits",
      "New School",
      "Good Stuff",
      "Sad Tape",
      "Country Rap",
      "Finest Lyricists",
      "Rap Workout",
      "Turn Up",
      "Chill Bars",
      "Lofi Hip Hop",
      "Rap Latino",
      "Jazzy Hip-Hop",
      "Grind Mode",
      "Hip Hop Beats",
      "new violence",
      "Sunny Rap",
    ],
    Rock: [
      "Hot New Rock",
      "Rock Hits",
      "mainstream",
      "Rock Icons Now",
      "Hard Rock Now",
      "heavy league",
      "Rock Essentials",
      "Modern Rock Essentials",
      "Women of Rock",
      "Black Icons of Rock",
      "Summer Rock",
      "Live Rock",
      "Yacht Rock",
      "Rise Up!",
      "Rock Road Trip",
      "Rock & Chill",
      "Rock Running",
      "Rock Workout",
      "Rock the Party",
      "Soft Rock",
      "Feel Good Rock",
      "is it emo?",
      "daaark",
      "Acoustic Rock",
      "Instrumental Rock",
      "Doomers",
      "Under the Influence",
      "Home Sweet Rock",
      "Say My Name",
      "Power Ballads",
      "Love You To Death",
      "Rock Love Songs",
      "Cosmic Sleep",
      "Soundcheck",
      "Grrrls!",
      "nu_rock",
      "Punk!",
      "Psychedelia",
      "Robot Rock",
      "Planet Stoner",
      "Viking Rock",
      "Queer Punk",
      "Indie Rock Now",
      "ANTI",
      "morras tumbadas",
      "Blues Rock Roadtrip",
      "Blues Coffee",
      "Blues at Work",
      "Blues today",
      "Blues Essentials",
      "Blues Guitar",
      "Acoustic Blues",
      "Women of Blues",
      "Early Blues",
      "Chicago Blues",
      "Metal Radar",
      "Metalcore",
      "Metal Hits",
      "French Metal",
      "Women of Metal",
      "Metal BBQ",
      "Live Monsters!",
      "Heavy Party",
      "Metal Workout",
      "Moshpit Training",
      "Run Like Hell",
      "Combat Zone",
      "Ssd Metal",
      "InstuMetal",
      "Murder Metal",
      "Love You to Death",
      "Shred for the Planet",
      "Baby Metal",
      "Symphonic Metal",
      "Industrial",
      "metal detector",
      "Deathcore",
      "This Is Hardcore",
      "Thrash Legacy",
      "Prog Metal",
      "Killed By Death Metal",
      "Epic Metal",
      "Folk Metal",
      "Black Metal",
      "Planet Stoner",
      "Synthwave",
    ],
    Pop: [
      "Global Hits",
      "Raddar Weekly",
      "Fresh Pop",
      "Pop All Stars",
      "Rising Pop",
      "TikTok Hits",
      "mainstream",
      "Summer Hits",
      "Girl power",
      "Queer Pop",
      "Women of Pop",
      "Chill Hits",
      "Acoustic Hits",
      "Soft Pop",
      "Bedroom Pop",
      "Pop Party",
      "Feel Good Pop",
      "Pop Workout",
      "Love Ballads",
      "Sad Pop",
      "Horror Pop",
      "Alt Pop",
      "hyperpop",
      "Top K-Pop",
      "Pop Fresco",
      "Pop Latino",
      "Pop México",
      "City Pop",
      "Pop Colombia",
      "#hitou",
      "Cocoripop",
      "Pop Chile",
      "Top J-Pop",
      "Nosso Pop",
    ],
    "R&B": [
      "R&B Hits",
      "Hot R&B",
      "Fresh R&B",
      "R&B New Faces",
      "Women of R&B",
      "blend",
      "Sunny R&B",
      "Chill R&B",
      "Acoustic R&B",
      "R&B Party Anthems",
      "Lofi R&B",
      "Run & Breathe",
      "Sweet Honey",
      "Slow Jam Essentials",
      "Midnight Love",
      "R&B Rewind",
      "Soul Essentials",
      "Queens of Soul",
      "Acoustic Soul",
      "Retro Soul",
      "Soul Covers",
      "Philly Soul",
      "Fresh Soul",
      "Piano Ballads",
      "New Funk",
      "50 shades of soul",
      "Neo Soul Hits",
      "Funk Essentials",
      "Soul to Chill",
      "who sampled?",
      "No Stress",
      "Soul Coffee",
      "Funky Hour",
      "Feel Good Soul",
      "Late Night Soul",
      "Morning Soul & Funk",
      "Disco Essentials",
      "Romantic Soul",
      "Soul Party",
    ],
    "Dance & Electronic": [
      "Global Dance Hits",
      "Open Air",
      "Chill House",
      "Mainstage",
      "Viral Dance",
      "Club Rush",
      "New Dance",
      "Feel Good Dance",
      "Electronic Hits",
      "Dance Party",
      "Fresh House",
      "Dance Pop",
      "Sample Groove",
      "Rave Revolution",
      "Dancing On My Own",
      "Euphoric",
      "Lounge",
      "EDM Workout",
      "Feel Good House",
      "Crying On The Dancefloor",
      "House Party",
      "House Workout",
      "The Love Club",
      "Summer Dance",
      "Acoustic Dance Hits",
      "Disco House",
      "Afro House",
      "Melodic Techno",
      "Hard Techno",
      "Queer Dance",
      "Techno Tunnel",
      "Country Dance",
      "phonk",
      "Tropical House",
      "Women of Dance",
      "Bass House",
      "Latin House",
      "Slap House",
      "Selectred DnB",
      "Tech House",
      "Indie Electro",
      "Selected House",
      "Deep House",
      "New French Touch",
      "Progressive Trance",
      "Hard Dance",
      "Hip House",
      "Indie Disco",
      "Nu Disco",
      "Black Icons of Dance",
      "Dancing Kids",
    ],
    World: [
      "Reggaeton 2.0",
      "Reggaeton Fresco",
      "Reggaeton Classics",
      "Reggaeton Hits",
      "Pop Perreo",
      "Chill Reggaeton",
      "Club Perreo",
      "Reggaeton Party",
      "Reggae Essentials",
      "Reggae Hits",
      "Dub Essentials",
      "Women of Reggae",
      "All Eyes on Jamaica",
      "Sunshine Reggae",
      "One Love",
      "Surf Bar",
      "Feel Good Reggae",
      "Schlager Queens",
      "Schlager Hits von heute",
      "Frischer Schlager",
      "Endlich wieder Malle",
      "Schlagerparty",
      "Schlager Super Hits",
      "Apres Ski",
      "Vereinsheim",
      "Schlagerparade",
      "Schlagerfeuer",
      "Schlager Sommer",
      "Feel Good Afro",
      "Afro Chill",
      "AFRO SZN",
      "Afrobeats Workout",
      "Afrobeats Hits",
      "Afro Party",
      "AfroPop",
      "New Afro",
      "Rap Bangers",
      "Fresh K-Pop",
      "OMGirls!",
      "K-Boys",
      "K-Pop House Party",
    ],
    "Indie & Alternative": [
      "New Alternative",
      "ANTI",
      "Explosión indie",
      "The Indie Cafe",
      "Women of Alternative",
      "Indie Supreme",
      "alt 50",
      "crush <3",
      "Unplugged",
      "Dreampop",
      "Indie Folk",
      "Post-Punk 2.0",
      "Silk",
      "Bedroom Pop",
      "Indie Electro",
      "Indie Disco",
      "Indie Sleaze",
      "fluid",
      "Indie Rock Now",
      "Alt Pop",
      "hyperpop",
      "cottagecore",
      "Gloom",
      "Lazy Indie",
      "Sunshine Indie",
      "safe place",
      "super sad",
      "you're dreaming",
      "who cares",
      "Feel Good Alternative",
      "Indie Love",
      "Chill Alternative",
      "Alterlatino",
      "Indie Party",
      "New Folk",
      "bloom",
      "Indie Folk Energy",
    ],
    Country: [
      "Indie Folk Energy",
      "New Country",
      "Country Summer",
      "bloom",
      "Indie Folk",
      "New Folk",
      "Drunk On Country",
      "Country Dance",
      "Country Hits",
      "Chill to Folk",
      "Americana Dreams",
      "cottagecore",
      "Country Party",
      "Country Rap",
      "Happy Folk",
      "Young Guns",
      "Women in Country",
      "For Love and Country",
    ],
    "Non-Music": [
      "Gaming Mode",
      "phonk",
      "Synthwave",
      "Fantasy Mode",
      "Adventure Mode",
      "Fight Mode",
      "Racing Mode",
    ],
    Jazz: [
      "Chill Jazz",
      "Jazz Now",
      "Women of Jazz",
      "Jazz is Dead",
      "Global Jazz",
      "Django Jazz",
      "Jazz Club",
      "Latin Jazz",
      "Jazzy Hip-Hop",
      "Lofi Jazz",
      "Jazz Crooners",
      "Smooth Jazz",
      "Acid Jazz",
      "Jazz Made in France",
      "Sunny Bossa Nova",
      "Jazz UK",
      "Japanese Jazz",
      "Jazz Coffee",
      "Feel Good Jazz",
      "Jazz Reading",
      "Jazzy Romance",
      "Jazz Lounge",
      "Jazz Cocoon",
      "Jazz For Working",
    ],
    "Latin Music": [
      "ídolas",
      "Corridos indie",
      "Boleros para el alma",
      "mamá bellaka",
      "mamá rockera",
      "La Conquista",
      "la nueva generación",
      "niña mal",
      "niña bien",
      "vámonos al norte",
      "ponte bloqueador",
      "Acapulco en la azotea",
      "My Partnership Year",
      "Salidas del barrio",
      "las reinas de la calle",
      "Queer Latin",
      "morras tumbadas",
      "mujeres chidas",
      "Pop Latino",
      "Alterlatino",
      "Salidas del Gabacho",
      "Rap Latino",
      "Pop Perreo",
      "Explosión indie",
    ],
  },

  spotifyPlaylists: {
    Country: [
      "Hot Country",
      "homegrown",
      "New Boots",
      "All New Country",
      "Breakout Country",
      "Big Country",
      "sad girl country",
      "coastal cowgirl",
      "Fresh Finds Country",
      "Country Headache",
      "Cozy Country",
      "Pop Country",
      "Country Tailgate",
      "neon cowgirl",
      "Women of Country",
      "Country Worldwide",
      "Sexy Country",
      "American Made",
      "Country Frequency",
      "Country Rap",
      "Country Rocks",
      "Country Club",
      "Energy Booster: Country",
      "Gulf & Western",
      "Texas Country Now",
      "Heart of Texas",
      "Country Soul",
      "Beast Mode Country",
      "Country Gaming",
      "Greener Pastures",
      "Cosmic Country",
      "Viral Country",
      "Heartland Country",
      "Wild Country",
      "Country Party",
      "Country Kind of Love",
      "scorned",
      "Country Drive",
      "Party Cove",
      "Fresh Finds Country",
      "Fresh Finds Folk",
      "Fresh Folk",
      "Roots Rising",
      "Indigo",
      "Folk Pop",
      "Today's Singer-Songwriters",
      "The Pulse of Americana",
      "Folk Frequency",
      "Farmers Market",
      "Grass Roots",
      "the new retro",
    ],
    "Dance & Electronic": [
      "mint",
      "Dance Rising",
      "Housewerk",
      "Bass Arcade",
      "Tech House Operator",
      "Chill Tracks",
      "Tantra",
      "Women of Electronic",
      "Hard Techno",
      "techno party",
      "Melodic Techno Elements",
      "metropolis",
      "Night Rider",
      "All New Dance",
      "EDM 2025",
      "Trance Mission",
      "Happy Beats",
      "Heart Beats",
      "New Dance Pop",
      "Open Air",
      "Brain Food",
      "TECHNO BUNKER",
      "planet rave",
      "Emotional Dance",
      "Dubstep Don",
      "Dance Hits",
      "Italo Disco",
      "Dance Party",
      "rave",
      "Poolside Disco",
      "Electronic + Dance Frequency",
      "Bass Lounge",
      "Jersey Club Heat",
      "Umami",
      "Trap Mojito",
      "phonk",
      "Golden Hour",
      "Deep House Relax",
      "Hype",
      "Ultra Gaming",
      "Electronic Circus",
      "creamy",
      "Orgánica",
      "Lowkey Tech",
      "Nasty Bits",
      "Latin House",
      "Viral Dance",
      "Massive Drum & Bass",
      "crying on the dance floor",
      "Fresh Finds Dance",
      "Shuffle Syndrome",
      "Big Room Dance",
      "Deep & Minimal",
      "Sad Beats",
      "DISCOLAND",
      "Altar",
      "Club Resistance",
      "Runway",
      "Bassline Bangers",
      "EDMéxico",
      "Deep House Grooves",
      "Tantra",
      "Fresh Finds Dance",
      "Fresh Finds Experimental",
    ],
    "Indie & Alternative": [
      "Fresh Finds Indie",
      "POLLEN",
      "Lorem",
      "Front Page Indie",
      "Indie Chillout",
      "Cph+",
      "Indie Pop",
      "sexy indie",
      "Sad Indie",
      "Today's Indie Rock",
      "Ethereal",
      "Fierce Femmes",
      "my life is a movie",
      "All New Indie",
      "Indie Twang",
      "undercurrents",
      "Indie Pop Hits",
      "Rarities",
      "Shoegaze Now",
      "Indie that hits different",
      "Indie Frequency",
      "Feel-Good Indie Rock",
      "velvet",
      "Infinite Indie Folk",
      "juniper",
      "Modern Psychedlia",
      "late night vibes",
      "side effects",
      "Oblique",
      "Bedroom Pop",
      "Lofi Indie",
      "Indie Sleaze",
      "Women of Indie",
      "anti pop",
      "borderless",
      "IRL ANGEL",
    ],
    Jazz: [
      "Fresh Finds Jazz",
      "State of Jazz",
      "Vocal Jazz",
      "Jazztronica",
      "Orbit",
      "Jazz-Funk",
      "Acid Jazz",
      "Prog Jazz",
    ],
    "Latin Music": [
      "Verano Forever",
      "Latin Hit Mix",
      "Baila Reggaeton",
      "Fresh Finds Latin",
      "Éxitos USA",
      "Tropical Hits",
      "Lo mejor del mes",
      "Fuego",
      "Afro Ritmo",
      "Viva Latino",
      "MANSIÓN REGGAETON",
      "Dembow Pegao",
      "Corridos Perrones",
      "Los Que Mandan - Mùsica Mexicana",
      "sad sierreño",
      "Fiesta y Desmadre",
      "La Lista Pop",
      "Fiesta",
      "La Privada",
      "el nuevo urbano",
      "Tropical Hits",
      "Puro Perreo",
      "Reggaeton Sexy",
      "Mucho Rap",
      "Trap Land",
      "La Mamalona",
      "Gym Latino",
      "Electro Corrido",
      "Rompiendo: Los Angeles",
      "Viral Latino",
      "All New Latin",
      "Super Cumbias",
      "Pop Romántico",
      "Rompiendo: Texas",
      "All New Música Mexicana",
      "Tumbado Romántico",
      "Merengue Mania",
      "Bachata Lovers",
      "Rompiendo: Miami",
      "Vibras",
      "Mal de Amores",
      "Amor Tropical",
      "Beast Mode Latin",
      "República Dembow",
      "#SadCuhHours💔",
      "Rompiendo: Puerto Rico",
      "Bien Machín",
      "chill latino",
      "perrear y llorar",
      "Latin Pop Today",
      "Latin Gaming",
      "Despierta y Sonríe",
      "Jangueo",
      "Novedades Dembow",
      "Buenas Vibras",
      "sad latino",
      "lofi latino",
      "Punta",
      "Latin Frequency",
      "New Latin Albums",
      "Latin Dinner",
      "el nuevo tropical",
      "indie feliz",
      "Women of Latin",
      "mi vida es una peli",
      "Women of Música Mexicana",
      "el nuevo indie",
      "Latin Folk",
      "mint Latin",
      "boleritos",
      "Rock Cristiano",
      "Mixto",
      "Amor Libre",
      "el nuevo pop",
      "Top Latin Indie",
      "Novedades Indie",
      "Rock Total",
      "BRILLO",
      "Our Voice",
      "Cumbia 420",
      "Fresh Finds Música Mexicana",
      "Inspiring Latinas",
      "Fresh Finds Música Mexicana",
      "Fresh Finds Latin",
    ],
    Pop: [
      "Today's Top Hits",
      "teen beats",
      "Pop Rising",
      "Pop Sauce",
      "Hot Hits USA",
      "OBSESSED",
      "SALT",
      "Just Good Music",
      "sad hour",
      "just hits",
      "Women of Pop",
      "young & free",
      "Chill Pop",
      "Soft Pop Hits",
      "Pop Frequency",
      "Party Hits",
      "Pop Drive",
      "Fresh Finds Pop",
      "K-Pop ON!",
      "New Dance Pop",
      "BBE",
      "Mega Hit Mix",
      "La Lista Pop",
      "Dance Pop Hits",
      "Fresh & Chill",
      "night pop",
      "soda",
      "Next Gen Singer-Songwriter",
      "Pop Covers",
      "RADAR US",
      "Pop Live",
      "Everyday Favorites",
      "Singled Out",
      "Crushing",
      "hot girl walk",
      "Folk Pop",
      "Line Dance",
      "bossa pop",
      "Romcom",
      "Hot Pink",
      "Anti-Valentine's Day",
      "Espresso Martini",
      "SUGAR",
      "All New Pop",
      "Confidence Boost",
      "Villain Mode",
      "Pumped Pop",
      "scarf season",
      "Good Vibes",
      "Mood Booster",
      "Make Out Jams",
      "Champagne Problems",
      "Sad Songs",
      "Viral Pop",
      "Vibey Pop",
      "Pop Frequency",
      "Summer Party",
      "Happy Hits!",
      "Pure Pop",
      "Coffee Break",
      "Feel Good Dinner",
      "Bangers",
      "Feel Great",
      "Hangover Cure",
      "Happy Beats",
      "Happy Vibes",
      "GLOW",
      "idk",
      "Stay Classy",
      "Energy Booster",
      "chill",
      "Beats to think to",
      "lofi",
      "sad",
      "Women of Poptimism",
      "Sad Bops",
      "sad indie",
      "Viral Hits",
      "sad songs",
      "sad songs to cry to",
      "Alone Again",
      "Fresh Finds Pop",
      "POP SAUCE",
    ],
    "R&B": [
      "Are & Be",
      "R&B Drive",
      "Fresh Finds R&B",
      "R&B Road",
      "R&B Gems",
      "R&B Only",
      "Chilled R&B",
      "New R&B",
      "R&B Frequency",
      "Soul Lounge",
      "Silk R&B",
      "Afro R&B",
      "Soul Music",
      "Neo-Soul Grooves",
      "Endless R&B",
      "Chill R&B",
      "Fresh Finds R&B",
    ],
    "Rap & Hip-Hop": [
      "RapCaviar",
      "Hip-Hop Drive",
      "Most Necessary",
      "Fresh Finds Hip-Hop",
      "Feelin' Myself",
      "Throwback Hip-Hop Jams",
      "Chill Rap",
      "New York Renaissance",
      "Detox",
      "Rap UK",
      "Beast Mode Hip-Hop",
      "Get Turnt",
      "Louder",
      "Modus Mio",
      "Bars Only",
      "Queer Hip-Hop",
      "Hip-Hop Frequency",
      "Viral Rap",
      "Afrobeats Hits",
      "It's A Vibe",
      "NMF Hip-Hop",
      "Rap Workout",
      "Women of Hip-Hop",
      "New Arrivals Hip-Hop",
      "Toronto Bred",
      "Brooklyn Drill",
      "underground",
      "SHIFT",
      "Feel-Good Rap",
      "Signed XOXO",
      "Swag",
      "Main Stage",
      "Drill",
      "Fresh Finds Hip-Hop",
    ],
    Rock: [
      "Rock Classics",
      "All New Rock",
      "Rock Hard",
      "Are You Even Real?",
      "The Pit",
      "New Metal Tracks",
      "Modern Hard Rock",
      "Rock This",
      "All New Metal",
      "New Noise",
      "Post Hardcore",
      "Women of Rock",
      "Rock Gaming",
      "Teen Angst",
      "Garage Rock",
      "ProgRAM",
      "Kickass Metal",
      "Beast Mode Rock",
      "Heavy Queens",
      "Altar",
      "Scene Queen",
      "Emo Forever",
      "Punk Unleashed",
      "Essential Alternative",
      "Alternative Frequency",
      "Pop Punk's Not Dead",
      "Rock Frequency",
      "Metal Essentials",
      "Rage Beats",
      "Hail & Horn",
      "Doom & Stoner Metal",
      "New Core",
      "Rock Drive",
      "Fresh Finds Rock",
    ],
    World: [
      "Afrobeats Hits",
      "Fuego Mundial",
      "Songs to Sing in the Car",
      "NMF Africa",
      "Afro Rhythms",
      "Afrosounds",
      "The Roots List",
      "Fresh Finds Africa",
    ],
  },

  mainGenre: [
    "Acoustic",
    "Children's",
    "Classical",
    "Country",
    "Dance & Electronic",
    "Holiday",
    "Indian Music",
    "Indie & Alternative",
    "Jazz",
    "Latin Music",
    "New Age",
    "Non-Music",
    "Pop",
    "R&B",
    "Rap & Hip-Hop",
    "Religious Music",
    "Rock",
    "World",
  ],
  songCategory: [
    "Chilling Out",
    "Happy & Upbeat",
    "Relaxed & Laid Back",
    "Work, Study, & Reading",
    "Hard & Heavy",
  ],
  songDescription: [
    "Live",
    "Studio",
    "Remix",
    "Cover",
    "Instrumental",
    "Reissue",
    "Alternate Version",
    "Instant Grat",
    "Pre-Save",
  ],
  songMood: [
    "Angry",
    "Chill",
    "Cool",
    "Dark",
    "Energetic",
    "Fast",
    "Feel Good",
    "Feeling Blue",
    "Fierce",
    "Fitness",
    "Focus",
    "Happy",
    "Heartbreak",
    "Heavy",
    "Intense",
    "Light",
    "Meditative",
    "Mellow",
    "Motivational",
    "Party",
    "Relaxing",
    "Romantic",
    "Sad",
    "Sexy",
    "Sleep",
    "Soft",
    "Upbeat",
    "None Of These",
  ],
  language: [
    "Abkhazian",
    "Afar",
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Aragonese",
    "Armenian",
    "Assamese",
    "Avaric",
    "Avestan",
    "Aymara",
    "Azerbaijani",
    "Bambara",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bihari",
    "Bislama",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Chamorro",
    "Chechen",
    "Chinese",
    "Church Slavic",
    "Chuvash",
    "Cornish",
    "Corsican",
    "Cree",
    "Croatian",
    "Czech",
    "Danish",
    "Divehi",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Faroese",
    "Fijian",
    "Finnish",
    "French",
    "Fulah",
    "Galician",
    "Ganda",
    "Georgian",
    "German",
    "Greek",
    "Guarani",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hebrew",
    "Herero",
    "Hindi",
    "Hiri Motu",
    "Hungarian",
    "Icelandic",
    "Ido",
    "Igbo",
    "Indonesian",
    "Interlingua",
    "Inuktitut",
    "Inupiaq",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kalaallisut",
    "Kannada",
    "Kanuri",
    "Kashmiri",
    "Kazakh",
    "Khmer",
    "Kikuyu",
    "Kinyarwanda",
    "Komi",
    "Kongo",
    "Korean",
    "Kuanyama",
    "Kurdish",
    "Kyrgyz",
    "Lao",
    "Latin",
    "Latvian",
    "Limburgish",
    "Lingala",
    "Lithuanian",
    "Luba-Katanga",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Manx",
    "Maori",
    "Marathi",
    "Marshallese",
    "Moldavian",
    "Mongolian",
    "Nauru",
    "Navajo",
    "Ndonga",
    "Nepali",
    "North Ndebele",
    "Northern Sami",
    "Norwegian",
    "Norwegian Bokmål",
    "Norwegian Nynorsk",
    "Nyanja",
    "Occitan",
    "Odia",
    "Ojibwa",
    "Oromo",
    "Ossetic",
    "Pali",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Rundi",
    "Russian",
    "Samoan",
    "Sango",
    "Sanskrit",
    "Sardinian",
    "Scottish Gaelic",
    "Serbian",
    "Shona",
    "Sichuan Yi",
    "Sindhi",
    "Slovak",
    "Slovenian",
    "Somali",
    "South Ndebele",
    "Southern Sotho",
    "Spanish",
    "Sudanese",
    "Swahili",
    "Swati",
    "Swedish",
    "Tagalog",
    "Tahitian",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tongan",
    "Tsonga",
    "Tswana",
    "Turkish",
    "Turkmen",
    "Twi",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Venda",
    "Vietnamese",
    "Volapük",
    "Walloon",
    "Welsh",
    "Western Frisian",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zhuang",
    "Zulu",
  ],
  listenersLocation: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo - Brazzaville",
    "Congo - Kinshasa",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte D'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard & McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle Of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "North Macedonia",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Islands",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Rwanda",
    "Réunion",
    "Samoa",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia & South Sandwich Islands",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Barthélemy",
    "St. Helena",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Martin",
    "St. Pierre & Miquelon",
    "St. Vincent & Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard & Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syria",
    "São Tomé & Príncipe",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "Türkiye",
    "U.S. Outlying Islands",
    "U.S. Virgin Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Wallis & Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands",
  ],

  artistCountry: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo - Brazzaville",
    "Congo - Kinshasa",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte D'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard & McDonald Islands",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle Of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "North Macedonia",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Islands",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Rwanda",
    "Réunion",
    "Samoa",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia & South Sandwich Islands",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Barthélemy",
    "St. Helena",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Martin",
    "St. Pierre & Miquelon",
    "St. Vincent & Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard & Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syria",
    "São Tomé & Príncipe",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "Türkiye",
    "U.S. Outlying Islands",
    "U.S. Virgin Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Wallis & Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands",
  ],

  LabelDistributor: [
    "_Indie",
    "!K7",
    "!K7 GSA",
    "3Tone",
    "3Tone GSA",
    "4AD",
    "12Tone",
    "13_31",
    "88 Rising",
    "300 Entertainment",
    "ABKCO",
    "Above Board",
    "ADA",
    "ADA Brazil",
    "ADA France",
    "ADA Iberia",
    "ADA Italy",
    "Africori",
    "Agora",
    "Alamo Records",
    "ALOADED AB",
    "Altafonte Latin",
    "Altafonte Brazil",
    "Altafonte Italy",
    "Altafonte Portugal",
    "Altafonte Spain",
    "Alter-K",
    "Amuseio AB",
    "Analekta",
    "Anthem Records",
    "ANTI-",
    "ANXT",
    "Ao Sul do Mundo",
    "Overtone Studios",
    "Aparté",
    "Apollo",
    "Apron Records",
    "Aquarius Records",
    "Arising Empire",
    "Arista",
    "Armada",
    "Arruada",
    "Artist First",
    "Artist Partner Group (APG)",
    "Arts Music",
    "ASCAP",
    "Asfalt",
    "Astralwerks / Capitol",
    "Asylum",
    "Atlantic Records",
    "Atlantic UK",
    "AudioSalad",
    "AudioSalad Norway",
    "Aus Music",
    "AVIE Records",
    "AWAL",
    "AWAL UK",
    "Azáfama",
    "Azuri",
    "Baco Records",
    "Balkaton",
    "Banzé",
    "Basic & Rough",
    "Bassivity Digital",
    "Because Music",
    "Because Portugal",
    "Beggars Group",
    "Beggars Group France",
    "Beggars Group UK",
    "Believe",
    "Believe (Classical)",
    "Believe (Latin)",
    "Believe Africa",
    "Believe Balkans",
    "Believe Brazil",
    "Believe Europe (Metal)",
    "Believe France",
    "Believe GSA",
    "Believe Italy",
    "Believe MENA",
    "Believe Nordics",
    "Believe Poland",
    "Believe Portugal",
    "Believe Singapore",
    "Believe Spain",
    "Beton Music",
    "Better Noise Music",
    "Big Beat",
    "Big Bit",
    "Big Loud Records",
    "Big Machine Label Group",
    "Bigo and Twigetti",
    "Biscoito Fino",
    "Blac Noize!",
    "Blackground",
    "BMG",
    "BMG Brazil",
    "BMG France",
    "BMG Italy",
    "BMG Spain",
    "BMI",
    "brandit",
    "BRM",
    "Broken Bow Records",
    "Cantaloupe",
    "Cantus",
    "Canvasback",
    "Capitol - Electronic & Dance",
    "Capitol CMG",
    "Capitol Records",
    "Cargo Digital France",
    "Cargo Digital GSA",
    "Cargo Records UK",
    "Cass Ching",
    "CD Baby",
    "CD Baby (Latin)",
    "Cedille",
    "Celinka",
    "Century Media",
    "Challenge Classics",
    "Cinematic Worldwide",
    "Cing Music",
    "City Slang",
    "CmdShft",
    "Columbia Records",
    "Communion Records",
    "Compass Records",
    "Concord Recorded Music",
    "Content Connect Africa",
    "Cosmic Burger",
    "Cousin",
    "Create Music Group",
    "Crni Cerak",
    "Croatia Records",
    "Crush",
    "Cruz Del Sur Music",
    "Cupula",
    "Dallas Records Croatia",
    "Dallas Records Slovenia",
    "Danal Entertainment",
    "Dancing Bear",
    "Danmark Music Group",
    "Dawn",
    "Dead Oceans",
    "Decca Records",
    "Deckdisk",
    "Def Jam",
    "Dekmantel",
    "Deutsche Grammophon",
    "DFSB Kollective",
    "Diepgraven Records",
    "Disco:Wax",
    "Diskover",
    "Disney Music",
    "DistroKid",
    "DistroKid Norway",
    "Ditto",
    "Ditto Africa",
    "Ditto Brazil",
    "Ditto France",
    "Ditto GSA",
    "Ditto Spain",
    "Divizzion",
    "Domino",
    "Dostava zvuka",
    "Downtown Music",
    "DTX",
    "Dvpper",
    "East West",
    "ECM",
    "Ejoya",
    "Elektra Records",
    "emPawa Africa",
    "EMPIRE",
    "Empire Africa",
    "Empire Latino",
    "Empire Portugal",
    "Empire WANA",
    "eMuzyka",
    "Encore Recordings",
    "Epic Records",
    "Epidemic Sound",
    "Epitaph Records",
    "EPM",
    "Equity/EQ",
    "Everlasting",
    "Fabien",
    "Family Ties Entertainment",
    "Farolatino",
    "Fat Possum",
    "Fayo Music",
    "FFRR",
    "Fluxus",
    "Força de Produção",
    "ForMusic",
    "Foundation Media",
    "Frontiers Records s.r.l.",
    "FUGA",
    "FUGA (K-Pop)",
    "FUGA Africa",
    "FUGA Brazil",
    "FUGA GSA",
    "FUGA Italy",
    "FUGA Portugal",
    "FUGA Spain",
    "FUGA UK",
    "Future Classic",
    "Fysisk Format",
    "Gaither Music Group",
    "Geffen Records",
    "Generacija Zed",
    "Genie Music",
    "Ghostly International",
    "Glassnote Entertainment Group LLC",
    "Glitch Records",
    "Good Output",
    "Graduation",
    "Gudu Records",
    "Hammerheart Records",
    "Harmonia Mundi",
    "Heir Wave Music Group",
    "HIT Records",
    "HITCO",
    "Hopeless Records",
    "Horus Music",
    "HYBE",
    "Hyperdub",
    "IDJDigital",
    "IDJTunes",
    "IDM Music",
    "IDOL France",
    "IDOL GSA",
    "iGroove",
    "iMusics",
    "In House Press",
    "INAXXS",
    "Independent Co. (Jessie)",
    "Independent Digital",
    "Indie Recordings",
    "Industre Works (Latin)",
    "Infamous PR",
    "InGrooves",
    "InGrooves (Latin)",
    "InGrooves Brazil",
    "InGrooves Denmark",
    "InGrooves GSA",
    "InGrooves Italy",
    "InGrooves Nordic",
    "InGrooves Spain",
    "Integral",
    "Integral (Classical)",
    "Integral France",
    "Integral UK",
    "Interscope (Latin)",
    "Interscope Records",
    "Ionekorea",
    "Island Records",
    "Kapa Records",
    "Karpo Media",
    "Kayax",
    "Kompakt",
    "Kondzilla",
    "Kontor New Media",
    "Kontra",
    "Kranky",
    "KT",
    "Kuroneko",
    "La Dolce Vita",
    "LAA",
    "Label Worx",
    "Label-Engine",
    "Lampshade Media",
    "Legacy Recordings",
    "Leitura Tropical",
    "Level",
    "Level: UP",
    "Local Action",
    "Locomotiva Azul",
    "Loma Vista Recordings",
    "Long Branch Records",
    "Long Play",
    "Lovers & Lollypops",
    "Lujo",
    "Mad Decent/Higher Ground",
    "Mad Solutions",
    "Made in BLKN",
    "Matador",
    "Match Attack",
    "Mau5trap",
    "MEDIAsounds",
    "Melides Art Records",
    "MENART Croatia",
    "MENART Serbia",
    "MENART Slovenia",
    "Mercury Records",
    "Merge",
    "Metal Blade Records",
    "MGM",
    "Midas Music",
    "Mighty Music",
    "MK",
    "MNRK (fka eOne)",
    "Modern Matters",
    "Modulor",
    "Mom + Pop",
    "Monarch",
    "Monument",
    "Moonbug",
    "Moonlee Records",
    "Motown Records",
    "Museu do Fado",
    "Music Adders",
    "Music As Usual",
    "MyMusic",
    "Mystic",
    "Nacional Records",
    "naïve",
    "Napalm Records",
    "Naxos",
    "Nettwerk Records",
    "New Amsterdam",
    "New Focus Recordings",
    "New West",
    "Nice Life",
    "Nick Music",
    "NIKA Records",
    "Ninja Tune",
    "Nonesuch",
    "Nuclear Blast",
    "ONErpm",
    "ONErpm (Latin)",
    "ONErpm Africa",
    "ONErpm Brazil",
    "ONErpm Spain",
    "Outhere",
    "OVO Sound",
    "Panela Rec",
    "Parabellum Official",
    "Paraty",
    "PENTATONE",
    "Photofinish Records",
    "PIAS",
    "PIAS France",
    "PIAS GSA",
    "PIAS Poland & Eastern Europe",
    "PIAS Spain",
    "Planet Mu",
    "Platoon",
    "Platoon Africa",
    "Play Two",
    "Playground Music Denmark",
    "Playground Music Norway",
    "PLZ Make It Ruins",
    "Polydor Records",
    "Polymoon",
    "Primeira Linha",
    "Prisma Music",
    "Prospero Classical",
    "Prosthetic Records",
    "Provident",
    "Quadio",
    "Range",
    "RCA - Hip-Hop and R&B",
    "RCA - Pop, Alternative & Dance",
    "RCA Inspiration",
    "recordjet",
    "Red Bull Records",
    "Red Star Productions",
    "Redeye France",
    "Redeye GSA",
    "Redeye Worldwide",
    "Repost / Soundcloud",
    "Repost / Soundcloud (Latin)",
    "Republic Records",
    "Republic of Music",
    "Republic Records (Latin)",
    "Reservoir",
    "Revolve",
    "Rhino Records",
    "Rimas",
    "Roadrunner Records",
    "Roc Nation",
    "Rotten Records",
    "Rough Trade Records",
    "Routenote",
    "Rubicon",
    "Saban Music Group",
    "Saddle Creek",
    "SBM",
    "SBS Music",
    "Scardona",
    "Season of Mist",
    "Secret City",
    "Secretly Distribution",
    "Seed",
    "SHARPTONE",
    "Signum Records",
    "Sipa Music",
    "Smithsonian Folkways",
    "Soave",
    "Solid State Records",
    "Som Livre",
    "Sony Classical",
    "Sony Masterworks",
    "Sony Music Africa",
    "Sony Music AU",
    "Sony Music Brazil",
    "Sony Music Canada",
    "Sony Music Denmark",
    "Sony Music France",
    "Sony Music GSA",
    "Sony Music Hong Kong",
    "Sony Music Italy",
    "Sony Music Korea",
    "Sony Music Latin",
    "Sony Music Legacy",
    "Sony Music México",
    "Sony Music Middle East",
    "Sony Music Nashville",
    "Sony Music Norway",
    "Sony Music Poland",
    "Sony Music Portugal",
    "Sony Music Singapore",
    "Sony Music Spain",
    "Sony Music UK",
    "Sound On",
    "Sparta",
    "Spectrum",
    "Spinefarm",
    "Spinefarm Records UK",
    "Spona",
    "Stem",
    "Stereofox",
    "Street Mission Records",
    "Sua Música",
    "SunPop",
    "Supa Squad",
    "Symphonic",
    "Symphonic Brazil",
    "Symphonic Latino",
    "System Records",
    "Tailored Communication",
    "TDKM",
    "Technicolour",
    "The Orchard",
    "The Orchard (Classical)",
    "The Orchard (Latin)",
    "The Orchard (Metal)",
    "The Orchard Balkans",
    "The Orchard Brazil",
    "The Orchard Denmark",
    "The Orchard France",
    "The Orchard GSA",
    "The Orchard Italy",
    "The Orchard Norway",
    "The Orchard Poland",
    "The Orchard Portugal",
    "The Orchard Spain",
    "Third Man",
    "Thirty Tigers",
    "Toby",
    "Tonika",
    "Toolroom Records",
    "Translation Loss Records",
    "Tratore",
    "Triple Threat",
    "TuneCore",
    "Uguru",
    "Ultra Records",
    "UMC",
    "UMe",
    "UMG Nashville",
    "UMLE",
    "Unique Leader Records",
    "UnitedMasters",
    "UnitedMasters Brazil",
    "Universal Music Africa Abidjan",
    "Universal Music Brazil",
    "Universal Music Denmark",
    "Universal Music France",
    "Universal Music GSA",
    "Universal Music Hong Kong",
    "Universal Music Italy",
    "Universal Music Korea",
    "Universal Music Norway",
    "Universal Music Poland",
    "Universal Music Portual",
    "Universal Music Singapore",
    "Universal Music South Africa",
    "Universal Music UK",
    "Universal Music Western Balkans",
    "Valentim de Carvalho",
    "Venice",
    "Verve",
    "Virgin Music",
    "Virgin Music - Electronic",
    "Virgin Music - Latin",
    "Virgin Music Balkans",
    "Virgin Music Portugal",
    "Virginia Records",
    "vise manje zauvijek",
    "Vydia",
    "Vydia Brazil",
    "Wagram France",
    "Wagram GSA",
    "Warner Classics",
    "Warner Music Australia",
    "Warner Music Brazil",
    "Warner Music Denmark",
    "Warner Music Finland",
    "Warner Music Germany",
    "Warner Music Hong Kong",
    "Warner Music Italy",
    "Warner Music Japan",
    "Warner Music Korea",
    "Warner Music Latina/Warner Latin",
    "Warner Music Middle East",
    "Warner Music Nashville/Elektra",
    "Warner Music Norway",
    "Warner Music Poland",
    "Warner Music Portugal",
    "Warner Music SEE",
    "Warner Music Singapore",
    "Warner Music South Africa",
    "Warner Music Spain",
    "Warner Music Sweden",
    "Warner Nashville",
    "Warner Records",
    "Warner Records UK",
    "Warp Records",
    "Wax Bodega",
    "Wiseband France",
    "Wiseband GSA",
    "Worldeater Records",
    "XL",
    "Year of the Rat Records",
    "Yem",
    "YG Entertainment & YG PLUS",
    "Young",
    "Zebralution Brazil",
    "Zebralution GSA",
    "Zebralution Portugal",
    "Zicer Inc.",
    "Ziiki Media",
    "Universal Music Group Classics",
    "5020 Records",
    "Symphonic Africa",
    "10K Projects",
    "Too Lost",
    "Distrokid GSA",
    "iMusician GSA",
    "Thrill Jockey",
    "Rich Music",
    "Torrez Music Group",
    "Nettwerk EU",
    "Pop Depression",
    "Krokodil Studio",
    "Xelon Digital",
    "Roster (SoundCloud)",
    "Intek Music",
    "93 SIGMA",
    "DashGo",
    "BMG UK",
    "The Orchard UK",
    "PIAS UK",
    "Ditto UK",
    "Absolute",
    "Island Records UK",
    "EMI (UK)",
    "Virgin Music UK",
    "Polydor Records UK",
    "Pulse Music Group",
    "0207 Def Jam",
    "Believe UK",
    "IDOL UK",
    "Fearless Records",
    "Artist Publishing Group (APG)",
    "Sony Music Entertainment (SME)",
    "Universal Music Group (UMG)",
    "Warner Music Group (WMG)",
    "Motown Gospel",
    "Re:Think",
    "Rise Records",
    "RBC Records",
    "MUGO",
    "ID Records",
    "London Records",
    "Because London Records",
    "Partisan",
    "Tonal Union",
    "SANTA ANNA",
    "Fundacja Muzyki Niezaleznej",
    "JuNouMi Records",
    "Peleton Records",
    "Seszele Records",
    "Soulspazm",
    "Universal Music Canada",
    "Mascot Records",
    "Alpha Classics",
    "Arcana",
    "B Records",
    "Bru Zane",
    "Channel Classics",
    "Château de Versailles Spectacles",
    "Eloquentia",
    "Cinquillo",
    "EnPhases",
    "Fuga Libera",
    "ICA Classics",
    "La Dolce Volta",
    "Linn Records",
    "MarchVivo",
    "Musique en Wallonie",
    "Muso",
    "Outnote Records",
    "Paradizo",
    "Phi",
    "Ramée",
    "Ricercar",
    "Roldán",
    "Shiiin",
    "Incises",
    "Getty Music (GTM)",
    "Dream",
    "Tamla Records",
    "First Word Records",
    "Kudos Records",
    "EGA Distro",
    "Fat Cat / 130701",
    "Audax Records",
    "Berliner Philharmoniker Recordings",
    "Chandos",
    "Colin Currie Records",
    "Evidence Classics",
    "King's College Cambridge",
    "LSO Live",
    "NoMadMusic",
    "The Cleveland Orchestra",
    "Télès Music",
    "Conscious Music Group",
    "Kartel Music Group",
    "Altafonte Music Distribution",
    "Evolution Ltd.",
    "HARD COPY Records",
    "SLCKR",
    "Sing Hosanna",
    "evokids",
    "evoXS",
    "evosound",
    "River Of Joy",
    "Disk Eyes",
    "Just Poppin",
    "Curb Records",
    "Daredo",
    "Noble Demon",
    "Zebralution US",
    "Zebralution UK",
    "We're Trying Records",
    "digdis!",
    "Palm Tree Records",
    "Blue Note Records",
    "Memphis Industries",
    "GYROstream",
    "Anjunabeats",
    "Vertigo / Capitol",
    "Chapter ONE Records",
    "Airforce1",
    "Electrola",
    "Urban Records",
    "Virgin Records Germany",
    "Polydor / Island (Germany)",
    "RCA Records",
    "Rebeat",
    "Bungalo",
    "GroundUP Music LLC",
    "SoundOn",
    "Jonas Entertainment Group",
    "Connect Music",
    "Sounds Australia",
    "International Anthem",
    "Delos",
    "ReLo-Co Music",
    "Cigol Music",
    "Hecho A Mano Music",
    "Mr. 305 Records",
    "Muve Recordings",
    "IDOL",
    "SideHustle",
    "Hidden Beach",
    "Warner Chappell Music (WCM)",
    "MOODWAVE",
    "Reach Records",
    "Chrysalis Records",
    "Puntilla",
    "Cygnus Music",
    "Ironshore Records USA",
    "BloodBlast",
    "Warner Music Canada",
    "Snapper Music",
    "Kscope Music",
    "Peaceville Records",
    "COLORSxSTUDIOS",
    "NMC Recordings",
    "Revelator",
  ],
  options: [
    "Mapping Request",
    "Release Priority",
    "Canonization",
    "Track Migration",
    "Misingested Content",
    "Missing Tracks",
    "Artwork Change",
    "Paywall Tier Moves",
    "Pro Unlimited Upgrade",
    "Profile Verification",
  ],

  soundCloudContact: [
    "Cameron Cox",
    "Caroline Adley",
    "Chris Johnson",
    "Denys Wilcox",
    "Drea Jackson",
    "Fatima Medrano",
    "Jack Bridges",
    "Jalen Parrish",
    "Matt Smith",
    "Roberto Bua",
    "Tricia Tranquillo",
    "Indie Label Submission",
    "Merlin Member Submission",
  ],
  promotionTerritories: [
    "US",
    "CA",
    "GB",
    "DE",
    "FR",
    "AU",
    "NZ",
    "NL",
    "IE",
    "IT",
    "ES",
    "CH",
    "BE",
    "PT",
    "SE",
    "NO",
    "DK",
    "FI",
  ],

  freshMusicFriday: [
    "Fresh Music Friday (US)",
    "Fresh Music Friday (CA)",
    "Fresh Music Friday (UK)",
    "Fresh Music Friday (AU)",
    "Fresh Music Friday (DE)",
    "Fresh Music Friday (FR)",
  ],

  playlistConsideration: [
    "¡ARRIBA!: Nueva Música Mexicana",
    "ACCELERATE: Future-Pop",
    "AFRO BOPS: New Afrobeats",
    "BACKROADS: Best Country Now",
    "BARS: Best UK Rap",
    "BASSBIN: Fresh Drums & Bass",
    "BELTERS: UK & Ireland Dance",
    "BOOMIN': Feel-Good Hip-Hop",
    "BOOTSTRAPS: New Country Rap",
    "BORDERLESS: Global Beats Now",
    "CHRISTMAS CLASSICS (SEASONAL)",
    "CLOSER: Emerging R&B",
    "CLUB HEAT: New Dance Now",
    "DIALED IN: Pop Hits",
    "DREAMS: Emerging Indie",
    "DRIPPIN': Best Rap Right Now",
    "EAR CANDY: Fresh Pop Picks",
    "FEMCEES: Best Female Rappers Now",
    "FIRESIDE: Warm Indie Sounds (SEASONAL)",
    "FIZZ: Tomorrow's Hits Today",
    "FRESCO: Fresh Latin Music",
    "GIANTS: New African Pop",
    "INFLUENCE: Viral Hits",
    "JAMZ: Best UK R&B",
    "K-POP and More",
    "LA MULTITUD: New Latin Pop",
    "LEVEL UP: EDM Next",
    "NEW + NOW: Essential New Music",
    "NEW YORK DRILL",
    "NOCHE BUENA: Latin Xmas (SEASONAL)",
    "ON THE UP: EDM Hits",
    "PORCH SWING: Emerging Folk, Country, Americana",
    "SHRED: Essential Metal",
    "SIZZLE: Hot UK Pop",
    "SOUNDCLOUD CHRISTMAS (SEASONAL)",
    "STITCHES: Indie New Arrivals",
    "TECHNO: New Techno Now",
    "THE DIVE: New Rock Now",
    "THE LOOK OUT: Tomorrow's Rap Hits",
    "TROPICAL POP",
    "TUNNEL: Best Electronic Now",
    "UNDERGROUND: New Underground Music",
    "VIBES: Best New R&B",
    "WARMS: Warm Soothing Soul (SEASONAL)",
  ],

  youtubePromotionSurface: [
    "Creator Music",
    "Programmed Playlist",
    "Shorts Audio Picker",
    "Living Room",
  ],
  youtubeReleaseStage: [
    "New Release",
    "Ongoing",
    "Pre-release (teasers, etc.)",
    "Previews",
    "Catalog",
    "Trending/Resurgent",
    "Anniversary",
    "Reissue",
    "Seasonal",
    "Re-promotion",
    "Pre-add/Pre-order",
  ],
  // youtubeSongDetails: [
  //   "Previews",
  //   "New Release",
  //   "Ongoing Priority",
  //   "Catalog",
  //   "Trending/Resurgent",
  //   "Anniversary",
  //   "Reissue",
  //   "Seasonal",
  // ],
  youtubeTerritories: [
    "United States",
    "United Kingdom",
    "Germany/Austria/Switzerland",
    "France",
    "Brazil",
    "Japan",
    "Canada",
    "Mexico",
    "Spain",
    "Italy",
    "Australia/New Zealand",
    "India",
    "South Korea",
    "Middle East/North Africa",
    "Argentina",
    "Colombia",
    "Nigeria",
    "Ukraine",
  ],
  soundCloudReleaseStage: [
    "New Release",
    "Ongoing",
    "Pre-release (teasers, etc.)",
    "Previews",
    "Catalog",
    "Trending/Resurgent",
    "Anniversary",
    "Reissue",
    "Seasonal",
    "Re-promotion",
    "Pre-add/Pre-order",
  ],
  siriusXmChannel: [
  "Attitude Franco",
  "The Indigiverse",
  "Influence Franco",
  "Mixtape: North",
  "North Americana",
  "Poplandia",
  "Racines Musicales",
  "SiriusXM Dhamaka",
  "Top of the Country Radio",
  "The Verge"
  ],

  // TIDAL specific options
  tidalArtistLevel: ["Developing", "Mid-Tier", "Established"],
  tidalPriorityLevel: ["Hot", "Medium", "Awareness"],
  tidalLocalMarket: ["Denmark", "Germany", "Poland", "Austria", "UK", "Switzerland"],

  // Vevo specific options
  vevoContentType: [
    "Acoustic video",
    "BTS",
    "Live Performance Video",
    "Lyric Video",
    "Official Music Video",
    "Playlist",
    "Pseudo Video",
    "Visualizer",
  ],
  appleSubgenre: [
    "Alternative",
    "Alternative Country",
    "Ambient",
    "Americana",
    "Blues",
    "Children's Music",
    "Classical",
    "Country",
    "Electronic",
    "Folk",
    "Funk",
    "Hip Hop/Rap",
    "Holiday",
    "House",
    "Indie Pop",
    "Indie Rock",
    "Instrumental",
    "Jazz",
    "Latin",
    "Piano",
    "Pop",
    "Pop Punk",
    "Pop/Rock",
    "Punk",
    "R&B/Soul",
    "Rock",
    "Singer/Songwriter",
    "Ska",
    "Smooth Jazz",
    "Soundtrack",
    "Violin",
    "Violin Jazz",
    "World",
  ],
  vevoSubgenre: [
    "Afrobeats",
    "Alternative",
    "Brazil",
    "Christian/Gospel",
    "Christmas",
    "Classical",
    "Country",
    "Dance/EDM",
    "Dancehall",
    "Hot AC",
    "Indie",
    "Jazz",
    "Latin",
    "Pop",
    "R&B/Soul",
    "Rap/Hip-Hop",
    "Reggae",
    "Rock",
    "Soundtrack",
    "Other",
  ],
  vevoRep: [
    "David McTiernan",
    "Cynthia Todd",
    "Jordan Ferree",
    "Julie Fernandez",
    "Sam Mackoff",
    "Messie Bangura",
    "Other",
  ],

  // Notable specific options
  notableSubmissionCategory: [
    "Priority Songwriter",
    "New Release",
    "Catalog Moment",
    "Created By Women",
  ],
  notableGlobalMusicProgram: [
    "EQUAL - Female Creators",
    "Frequency - Black Creators",
    "GLOW - LGBTQIA+ Creators",
    "RADAR - Emerging Creators",
  ],
};

// We'll define a separate object for subgenres that depend on main genre
// Spotify subgenre mappings
export const dspSubgenres: DSPSubgenreMap = {
  spotify: {
    Acoustic: [
      "Acoustic Country",
      "Acoustic Pop",
      "Blues Singer-Songwriter",
      "Folk Singer-Songwriter",
      "Indie Singer-Songwriter",
      "Pop Singer-Songwriter",
      "Rock Singer-Songwriter",
      "Singer-Songwriter",
      "Soul Singer-Songwriter",
    ],
    "Children's": [
      "Children's Music",
      "Lullaby",
    ],
    Classical: [
      "Ballet",
      "Baroque",
      "Carnatic Classical",
      "Chamber Music",
      "Choral",
      "Classical",
      "Classical Crossover",
      "Classical Piano",
      "Concerto",
      "Contemporary Classical",
      "Early Music",
      "Electronic Classical",
      "Expressionism",
      "Gregorian Chant",
      "Hindustani Classical",
      "Impressionism",
      "J-Classical",
      "Medieval",
      "Minimalism",
      "Neoclassical",
      "Opera",
      "Orchestra",
      "Orchestral",
      "Renaissance",
      "Romantic",
      "Score",
      "Symphony",
    ],
    Country: [
      "Acoustic Country",
      "Alt Country",
      "Ambient Folk",
      "Americana",
      "Anti-Folk",
      "Basque Folk (Folk Vasco)",
      "Bluegrass",
      "Blues Roots",
      "Castilian Folk (Folk Castellano)",
      "Catalan Folk (Folk Catalán)",
      "Celtic",
      "Celtic Punk",
      "Celtic Rock",
      "Classic Country",
      "Country",
      "Country Blues",
      "Country Christian",
      "Country Hip Hop",
      "Country Québécois",
      "Country Rock",
      "Folk",
      "Folk Metal",
      "Folk Pop",
      "Folk Punk",
      "Folk Québécois",
      "Folk Rock",
      "Folk Singer-Songwriter",
      "Honky Tonk",
      "Indie Bluegrass",
      "Indie Folk",
      "Latin Country",
      "Neofolk",
      "Newgrass",
      "Outlaw Country",
      "Pop Country",
      "Red Dirt",
      "Retro Rock",
      "Rockabilly",
      "Roots Reggae",
      "Roots Rock",
      "Sea Shanties",
      "Southern Gothic",
      "Southern Rock",
      "Texas Country",
      "Traditional Country",
      "Traditional Folk",
    ],
    "Dance & Electronic": [
      "Acid House",
      "Acid Jazz",
      "Acid Rock",
      "Acid Techno",
      "Alternative Dance",
      "Amapiano",
      "Ambient",
      "Ambient Drone",
      "Ambient Folk",
      "Ambient House",
      "Ambient Noise",
      "Avant-garde",
      "Ballroom Vogue",
      "Baltimore Club",
      "Bass",
      "Bass House",
      "Bassline",
      "Big Beat",
      "Big Room",
      "Boogie",
      "Brazilian Phonk",
      "Breakbeat",
      "Breakcore",
      "Budots",
      "Chicago House",
      "Chillstep",
      "Chillwave",
      "Christian EDM",
      "Christian Lo-Fi",
      "Club Music",
      "Cold Wave",
      "Dance",
      "Dance Pop",
      "Dark Ambient",
      "Deathstep",
      "Deep House",
      "Disco",
      "Disco House",
      "Downtempo",
      "Drift Phonk",
      "Drone",
      "Drum and Bass",
      "Drumstep",
      "Dub Techno",
      "Dubstep",
      "EBM",
      "EDM",
      "EDM Trap",
      "Electro",
      "Electro Corridos",
      "Electro House",
      "Electro R&B",
      "Electro Swing",
      "Electroacoustic",
      "Electroclash",
      "Electrocumbia",
      "Electronic",
      "Electronic Classical",
      "Electronic Flamenco (Flamenco electrónico)",
      "Electronic R&B",
      "Electronica",
      "Electropop",
      "Epadunk",
      "Eurodance",
      "Experimental",
      "Experimental Beats",
      "Footwork",
      "French House",
      "Frenchcore",
      "Funk Beats",
      "Funk Carioca",
      "Funkot",
      "Funky House",
      "Future Bass",
      "Future Funk",
      "Future House",
      "G-House",
      "Gabber",
      "Glitch",
      "Gqom",
      "Guaracha",
      "Happy Hardcore",
      "Hard House",
      "Hard Techno",
      "Hardcore Techno",
      "Hardstyle",
      "Hardtekk",
      "Hi-NRG",
      "Hip House",
      "House",
      "Hyperpop",
      "Hypertechno",
      "IDM",
      "Indie Dance",
      "Indie Electronic",
      "Italo Dance",
      "Italo Disco",
      "Jazz Beats",
      "Jazz House",
      "Jersey Club",
      "Jungle",
      "Kwaito",
      "Latin House",
      "Liquid Funk",
      "Lo-Fi Beats",
      "Lo-Fi Hip Hop",
      "Lo-Fi Hip-Hop",
      "Lo-Fi House",
      "Lo-Fi Indie",
      "lowercase",
      "Madchester",
      "Mahraganat",
      "Melbourne Bounce",
      "Melodic Bass",
      "Melodic House",
      "Melodic Techno",
      "Miami Bass",
      "Minimal Techno",
      "Moombahton",
      "Musique Concrète",
      "New Orleans Bounce",
      "New Rave",
      "New Wave",
      "Nightcore",
      "Nu Disco",
      "Organic House",
      "Philly Club",
      "Plunderphonics",
      "Post-Disco",
      "Post-Rock",
      "Progressive House",
      "Progressive Trance",
      "Psychedelic Electronic",
      "Psytrance",
      "Rally House",
      "Reggaeton",
      "Riddim",
      "Rominimal",
      "Russemusikk",
      "Shamstep",
      "Slap House",
      "Space Music",
      "Speedcore",
      "Stutter House",
      "Synthpop",
      "Synthwave",
      "Tech House",
      "Techno",
      "Trance",
      "Trap",
      "Trap Beats",
      "Tribal House",
      "Trip Hop",
      "Tropical House",
      "UK Funky",
      "UK Garage",
      "UK Grime",
      "Vaporwave",
      "Vinahouse",
      "Vocal Downtempo",
      "Witch House",
    ],
    "Indie & Alternative": [
      "Alternative",
      "Alternative Dance",
      "Alternative Hip Hop",
      "Alternative Metal",
      "Alternative Pop",
      "Alternative R&B",
      "Alternative Rock",
      "Arab Trap",
      "Art Pop",
      "Bedroom Pop",
      "Bubblegum Pop",
      "Chinese Indie",
      "Darkwave",
      "Dream Pop",
      "Electroclash",
      "Emo",
      "Emo Rap",
      "Experimental Hip Hop",
      "Garage Rock",
      "German Indie",
      "German Indie Pop",
      "Hindi Indie",
      "Hyperpop",
      "Indian Indie",
      "Indie",
      "Indie Bluegrass",
      "Indie Dance",
      "Indie Electronic",
      "Indie Folk",
      "Indie Jazz",
      "Indie Mexicano",
      "Indie Pop",
      "Indie Punk",
      "Indie Québécois",
      "Indie R&B",
      "Indie Rock",
      "Indie Singer-Songwriter",
      "Indie Soul",
      "Indie Viet",
      "Indonesian Indie",
      "Indonesian Indie Rock",
      "Industrial",
      "J-Indie",
      "Jangle Pop",
      "Krautrock",
      "Lo-Fi",
      "Lo-Fi Beats",
      "Lo-Fi Hip-Hop",
      "Lo-Fi Indie",
      "Lo-Fi Pop",
      "Lo-Fi Rock",
      "Maghreb Indie",
      "Midwest Emo",
      "Pinoy Alternative",
      "Pinoy Indie",
      "Post-Punk",
      "Psychedelic",
      "Shoegaze",
      "Slowcore",
      "Soft Rock",
      "Taiwanese Indie",
      "Thai Indie Pop",
      "Thai Indie Rock",
      "Traditional Folk",
    ],
    Jazz: [
      "Acid Jazz",
      "Adult Standards",
      "Afro-Cuban Jazz",
      "Ambient Jazz",
      "Bebop",
      "Big Band",
      "Boogie-Woogie",
      "Brass Band",
      "Brazilian Jazz",
      "Christian Jazz",
      "Contemporary Jazz",
      "Cool Jazz",
      "Ethiopian Jazz",
      "Exotica",
      "Experimental Jazz",
      "Flamenco Jazz",
      "Free Jazz",
      "French Jazz",
      "Hard Bop",
      "Indie Jazz",
      "Indonesian Jazz",
      "Jazz",
      "Jazz Ballads",
      "Jazz Beats",
      "Jazz Funk",
      "Jazz Fusion",
      "Jazz House",
      "Jazz Pop",
      "Jazz Rap",
      "Jazztronica",
      "Latin Jazz",
      "Lounge",
      "Post Bop",
      "Ragtime",
      "Smooth Jazz",
      "Soul Jazz",
      "Swing Music",
      "Vocal Jazz",
    ],
    "Latin Music": [
      "Argentine Rock",
      "Arrocha",
      "Axé",
      "Bachata",
      "Banda",
      "Bolero",
      "Bossa Nova",
      "Brazilian Funk",
      "Brazilian Gospel",
      "Brazilian Jazz",
      "Brazilian Pop",
      "Brazilian Rock",
      "Brega",
      "Brega Funk",
      "Cha Cha Cha",
      "Champeta",
      "Chicha",
      "Colombian Pop",
      "Corrido",
      "Corridos Bélicos",
      "Corridos Tumbados",
      "Cumbia",
      "Cumbia Norteña",
      "Cumbia Sonidera",
      "Dembow",
      "Dembow Belico",
      "Duranguense",
      "Electro Corridos",
      "Electrocumbia",
      "Flamenco",
      "Flamenco Chill",
      "Flamenco Jazz",
      "Flamenco Pop",
      "Flamenco Urbano",
      "Folclor Andino",
      "Folclor Llanero",
      "Folclor Pacifico",
      "Folklore Argentino",
      "Forró",
      "Forró Tradicional",
      "Funk Consciente",
      "Grupera",
      "Guaracha",
      "Huayno",
      "Latin",
      "Latin Afrobeats",
      "Latin Alternative",
      "Latin Country",
      "Latin Dance",
      "Latin Folk",
      "Latin Folklore",
      "Latin Hip Hop",
      "Latin House",
      "Latin Indie",
      "Latin Jazz",
      "Latin Pop",
      "Latin R&B",
      "Latin Rock",
      "Mambo",
      "Mambo Chileno",
      "Mariachi",
      "Merengue",
      "Mexican Hip Hop",
      "MPB",
      "Música Mexicana",
      "Música Nativista",
      "Música Popular Colombiana",
      "Música Tropical",
      "Neoperreo",
      "Norteño",
      "Norteño Sax",
      "Nueva Trova",
      "Pagode",
      "Pagode Baiano",
      "Pentecostal",
      "Pop Leve",
      "Pop Urbano",
      "Punta",
      "Punto Guajiro",
      "Ranchera",
      "Rap Nacional",
      "Reggae En Español",
      "Reggaeton",
      "Reggaeton Chileno",
      "Reggaeton Mexicano",
      "RKT",
      "Rock en español",
      "Rock Mexicano",
      "Sad Sierreño",
      "Salsa",
      "Salsa Choke",
      "Samba",
      "Seresta",
      "Sertanejo",
      "Sertanejo Tradicional",
      "Sertanejo Universitário",
      "Sierreño",
      "Ska Mexicano",
      "Son Cubano",
      "Son Jarocho",
      "Tango",
      "Techengue",
      "Tecnobrega",
      "Tejano",
      "Timba",
      "Trap Argentino",
      "Trap Chileno",
      "Trap Latino",
      "Trova",
      "Turreo",
      "Urbano Latino",
      "Vallenato",
      "Villancicos",
      "Zouk",
    ],
    "Non-Music": [
      "Ambient Noise",
      "ASMR",
      "Audio Plays",
      "Binaural Beats",
      "Comedy",
      "Fiction",
      "Nature Sounds",
      "Noise Music",
      "Nonfiction",
      "Poetry",
      "Spoken Word",
    ],
    Pop: [
      "Afrikaans Pop",
      "Afrobeat",
      "Arabesk",
      "Art Pop",
      "Austro Pop",
      "Bangla Pop",
      "Baroque Pop",
      "Batak",
      "Bedroom Pop",
      "Bhojpuri Pop",
      "Brazilian Pop",
      "Britpop",
      "Bubblegum Pop",
      "C-Pop",
      "Cantopop",
      "Chanson",
      "Chanson Alternative",
      "Christmas",
      "City Pop",
      "Colombian Pop",
      "Dance Pop",
      "Dangdut",
      "Dansband",
      "Dansk Pop",
      "Dansktop",
      "Desi Pop",
      "Deutschpop",
      "Dream Pop",
      "Easy Listening",
      "Egyptian Pop",
      "Electropop",
      "Europop",
      "Folk Pop",
      "French Indie Pop",
      "Funk Pop",
      "German Indie Pop",
      "Gujarati Pop",
      "Haryanvi Pop",
      "Hindi Pop",
      "Hyperpop",
      "Indie Pop",
      "Indonesian Pop",
      "Iskelmä",
      "J-Pop",
      "Jangle Pop",
      "Jazz Pop",
      "K-Ballad",
      "K-Pop",
      "Kannada Pop",
      "Kayokyoku",
      "Kundiman",
      "Lagu Jawa",
      "Lagu Maluku",
      "Lagu Timur",
      "Latin Pop",
      "Lo-Fi Pop",
      "M-Pop",
      "Maghreb Pop",
      "Malay Pop",
      "Malayalam Pop",
      "Mandopop",
      "Marathi Pop",
      "Mizrahi",
      "Mizrahit",
      "Moroccan Pop",
      "Musicals",
      "Nederpop",
      "New Age",
      "New Wave",
      "Norsk Pop",
      "OPM",
      "P-Pop",
      "Pop",
      "Pop Country",
      "Pop Française",
      "Pop Kreatif",
      "Pop Leve",
      "Pop Punk",
      "Pop Québécois",
      "Pop Québécoise",
      "Pop R&B",
      "Pop Rap",
      "Pop Rock",
      "Pop Singer-Songwriter",
      "Pop Soul",
      "Pop Urbaine",
      "Pop Urbano",
      "Power Pop",
      "Punjabi Pop",
      "R&B",
      "R&B Québécois",
      "Reggae Pop",
      "Retro Pop",
      "Schlager",
      "Schlagerparty",
      "Shimmer Pop",
      "Soft Pop",
      "Soul",
      "Soundtrack",
      "Suomipop",
      "Swedish Pop",
      "Synthpop",
      "T-Pop",
      "Taiwanese Pop",
      "Tamil Pop",
      "Telugu Pop",
      "Thai Pop",
      "Turkce Pop",
      "V-Pop",
      "Vocaloid",
      "Worship Pop",
    ],
    "R&B": [
      "Afro R&B",
      "Afro Soul",
      "Alternative R&B",
      "Boogie",
      "Bounce",
      "Canto R&B",
      "Chinese R&B",
      "Christian R&B",
      "Classic Soul",
      "Contemporary R&B",
      "Crunk",
      "Dark R&B",
      "Disco",
      "Doo-wop",
      "Electro R&B",
      "Electronic R&B",
      "French R&B",
      "Funk",
      "Funk Beats",
      "Funk Bruxaria",
      "Funk Gospel",
      "Funk Melody",
      "Funk Pop",
      "Funk Rock",
      "Future Funk",
      "Go-Go",
      "Indie R&B",
      "Indie Soul",
      "Indonesian R&B",
      "J-R&B",
      "Jazz Funk",
      "Latin R&B",
      "Motown",
      "Neo Soul",
      "New Jack Swing",
      "Northern Soul",
      "Philly Soul",
      "Pinoy R&B",
      "Pop R&B",
      "Pop Soul",
      "Quiet Storm",
      "R&B",
      "R&B Québécois",
      "Retro Soul",
      "Soul",
      "Soul Blues",
      "Soul House",
      "Soul Jazz",
      "Soul Singer-Songwriter",
      "Trap Soul",
      "UK Funky",
      "UK R&B",
      "Vaporwave",
    ],
    "Rap & Hip-Hop": [
      "Afro Adura",
      "Afro Soul",
      "Afrobeats",
      "Afrogospel",
      "Afropop",
      "Afroswing",
      "Algerian Hip-Hop",
      "Alternative Hip Hop",
      "Alternative R&B",
      "Amapiano",
      "Anime Rap",
      "Arab Trap",
      "Arabic Hip Hop",
      "Asakaa",
      "Aussie Drill",
      "Boom Bap",
      "Bounce",
      "Brooklyn Drill",
      "Chicago Drill",
      "Chinese Hip Hop",
      "Cloud Rap",
      "Country Hip Hop",
      "Crunk",
      "Dansk Rap",
      "Desi Hip Hop",
      "Deutschrap",
      "Drill",
      "East Coast Hip Hop",
      "Egyptian Hip Hop",
      "Emo Pop",
      "Emo Rap",
      "Experimental Hip Hop",
      "Freestyle",
      "French Rap",
      "Funk Beats",
      "Funk Carioca",
      "Funk Consciente",
      "G-Funk",
      "Gangster Rap",
      "Ghanaian Hip Hop",
      "Grime",
      "Hardcore Hip Hop",
      "Hip Hop",
      "Hip House",
      "Horrorcore",
      "Hyphy",
      "Indonesian Hip Hop",
      "J-Rap",
      "Jazz Beats",
      "Jazz Rap",
      "K-Rap",
      "Khaleeji Hip-Hop",
      "Latin Afrobeat",
      "Latin Hip Hop",
      "Lo-Fi Beats",
      "Lo-Fi Hip Hop",
      "Lo-Fi Hip-Hop",
      "Malay Hip Hop",
      "Malayalam Hip Hop",
      "Melodic Rap",
      "Mexican Hip Hop",
      "Moroccan Hip-Hop",
      "Moroccan Rap",
      "Motswako",
      "New York Drill",
      "Nigerian Drill",
      "Norsk Rap",
      "Old School Hip Hop",
      "Phonk",
      "Pinoy Hip Hop",
      "Pop Rap",
      "Punjabi Hip Hop",
      "Rage Rap",
      "Rap",
      "Rap Chrétien",
      "Rap Ivoire",
      "Rap Metal",
      "Rap Nacional",
      "Rap Napoletano",
      "Rap Québécois",
      "Rap Rock",
      "Rap Tuga",
      "Reggaeton",
      "Sexy Drill",
      "Southern Hip Hop",
      "Suomirap",
      "Tamil Hip Hop",
      "Thai Hip Hop",
      "Thai Trap",
      "Trap",
      "Trap Argentino",
      "Trap Beats",
      "Trap Brasileiro",
      "Trap Chileno",
      "Trap Funk",
      "Trap Italiana",
      "Trap Latino",
      "Trap Metal",
      "Tunisian Hip-Hop",
      "Turkce Rap",
      "UK Drill",
      "UK Grime",
      "Underground Hip Hop",
      "Vietnamese Hip Hop",
      "West Coast Hip Hop",
    ],
    "Religious Music": [
      "Afrogospel",
      "Alté Gospel",
      "Bhajan",
      "Brazilian Gospel",
      "Catholic Music",
      "Christian Alternative",
      "Christian Bluegrass",
      "Christian EDM",
      "Christian Folk",
      "Christian Hip Hop",
      "Christian Jazz",
      "Christian Lo-Fi",
      "Christian Music",
      "Christian Pop",
      "Christian R&B",
      "Christian Reggae",
      "Christian Reggaeton",
      "Christian Rock",
      "Contemporary Christian Music",
      "Country Christian",
      "Devotional",
      "Fújì",
      "Funk Gospel",
      "Gnawa",
      "Gospel",
      "Gospel Blues",
      "Hymns",
      "Liturgical",
      "Música Adventist",
      "Pagode Gospel",
      "Pentecostal Music",
      "Sertanejo Gospel",
      "Sholawat",
      "Southern Gospel",
      "Spiritual",
      "Sufi",
      "Traditional Gospel",
      "Worship",
      "Worship Pop",
    ],
    Rock: [
      "Acid Rock",
      "Afrikaans",
      "Alternative",
      "Alternative Metal",
      "Alternative Rock",
      "Anatolian Rock",
      "AOR",
      "Arena Rock",
      "Argentine Rock",
      "Art Rock",
      "Bisrock",
      "Black Metal",
      "Blues",
      "Blues Rock",
      "Blues Roots",
      "Blues Singer-Songwriter",
      "Boogie-Woogie",
      "Brazilian Rock",
      "Celtic Punk",
      "Celtic Rock",
      "Chicago Blues",
      "Chinese Rock",
      "Classic Blues",
      "Classic Rock",
      "Country Blues",
      "Country Rock",
      "Death Metal",
      "Deathcore",
      "Deathrock",
      "Delta Blues",
      "Djent",
      "Doom Metal",
      "Drone Metal",
      "Egg Punk",
      "Emo",
      "Emo Rap",
      "Experimental Rock",
      "Folk Metal",
      "Folk Punk",
      "Folk Rock",
      "Funk Rock",
      "Garage Rock",
      "Glam Metal",
      "Glam Rock",
      "Gospel Blues",
      "Gothic Metal",
      "Gothic Rock",
      "Grindcore",
      "Groove Metal",
      "Grunge",
      "Hard Rock",
      "Hardcore",
      "Hardcore Punk",
      "Heavy Metal",
      "Hill Country Blues",
      "Horror Punk",
      "Indie Mexicano",
      "Indie Punk",
      "Indie Rock",
      "Indonesian Indie Rock",
      "Indonesian Rock",
      "Indorock",
      "Industrial",
      "Industrial Metal",
      "Industrial Rock",
      "J-Rock",
      "Jam Band",
      "Jump Blues",
      "K-Rock",
      "Krautrock",
      "Lo-Fi Rock",
      "Louisiana Blues",
      "Madchester",
      "Math Rock",
      "Mathcore",
      "Medieval Metal",
      "Melodic Death Metal",
      "Melodic Hardcore",
      "Metal",
      "Metalcore",
      "Midwest Emo",
      "Modern Blues",
      "Neo-Psychedelic",
      "Noise Rock",
      "Nu Metal",
      "Pinoy Rock",
      "Pop Punk",
      "Pop Rock",
      "Post-Grunge",
      "Post-Hardcore",
      "Post-Punk",
      "Post-Rock",
      "Power Metal",
      "Power Pop",
      "Progressive Metal",
      "Progressive Rock",
      "Proto-punk",
      "Psychedelic",
      "Psychobilly",
      "Punk",
      "Punk Rap",
      "Queercore",
      "Rap Metal",
      "Rap Rock",
      "Retro Rock",
      "Riot Grrrl",
      "Rock",
      "Rock and Roll",
      "Rock en español",
      "Rock Mexicano",
      "Rock Québécois",
      "Rock Singer-Songwriter",
      "Rockabilly",
      "Roots Rock",
      "Screamo",
      "Shoegaze",
      "Ska",
      "Ska Punk",
      "Skate Punk",
      "Slowcore",
      "Sludge Metal",
      "Soft Rock",
      "Soul Blues",
      "Southern Rock",
      "Space Rock",
      "Speed Metal",
      "Stoner Metal",
      "Stoner Rock",
      "Suomirock",
      "Surf Rock",
      "Symphonic Metal",
      "Texas Blues",
      "Thai Rock",
      "Thrash Metal",
      "Trap Metal",
      "Yacht Rock",
    ],
    World: [
      "3 Step",
      "Afrikaans",
      "Afrikaans Contemporary",
      "Afrikaans Pop",
      "Afro Adura",
      "Afro House",
      "Afro R&B",
      "Afro Soul",
      "Afro Tech",
      "Afrobeat",
      "Afrobeats",
      "Afrogospel",
      "Afropiano",
      "Afropop",
      "Afroswing",
      "Agronejo",
      "Algerian Chaabi",
      "Alté",
      "Amapiano",
      "Anatolian Rock",
      "Anime",
      "Arab Trap",
      "Arabesk",
      "Arabic Hip Hop",
      "Asakaa",
      "Austro Pop",
      "Axé",
      "Azonto",
      "Bacardi",
      "Bachata",
      "Bangla Pop",
      "Basque Folk (Folk Vasco)",
      "Bhajan",
      "Bhangra",
      "Bhojiwood",
      "Bhojpuri Pop",
      "Bikutsi",
      "Blues Singer-Songwriter",
      "Bollywood",
      "Bongo Flava",
      "Bongo Piano",
      "Bossa Nova",
      "Brazilian Bass",
      "Brazilian Funk",
      "Brazilian Gospel",
      "Brazilian Jazz",
      "Brazilian Phonk",
      "Brazilian Pop",
      "Brazilian Rock",
      "Brega",
      "Brega Funk",
      "Cajun",
      "Calypso",
      "Candombe",
      "Cantautorato Italiano",
      "Canto R&B",
      "Canzone Napoletana",
      "Carimbó",
      "Carnatic Classical",
      "Castilian Folk (Folk Castellano)",
      "Catalan Folk (Folk Catalán)",
      "Celtic",
      "Chamamé",
      "Chanson",
      "Chanson Alternative",
      "Chanson Québécoise",
      "Chinese R&B",
      "Christian Reggae",
      "Christian Reggaeton",
      "Chutney",
      "City Pop",
      "Country Québécois",
      "Coupé Décalé",
      "Cuarteto",
      "Dabke",
      "Dancehall",
      "Dangdut",
      "Dansband",
      "Dansk Pop",
      "Dansk Rap",
      "Dembow",
      "Desi",
      "Desi Hip Hop",
      "Desi Pop",
      "Deutschpop",
      "Deutschrap",
      "Disco Polo",
      "Dub",
      "Egyptian Hip Hop",
      "Egyptian Pop",
      "Egyptian Shaabi",
      "Enka",
      "Entekhno",
      "Ethiopian Jazz",
      "Fado",
      "Filmi",
      "Flamenco",
      "Folclor Andino",
      "Folclor Llanero",
      "Folclor Pacifico",
      "Folk",
      "Folk Québécois",
      "Folklore Argentino",
      "Folklore Québécois",
      "Forró",
      "Forró Tradicional",
      "French House",
      "French Indie Pop",
      "French Jazz",
      "French R&B",
      "French Rap",
      "Funk Bruxaria",
      "Funk Consciente",
      "Funk de BH",
      "Funk Melody",
      "Gengetone",
      "German Indie",
      "German Indie Pop",
      "Ghanaian Hip Hop",
      "Ghazal",
      "Gqom",
      "Gufeng",
      "Gujarati Garba",
      "Gujarati Pop",
      "Hakka",
      "Harana",
      "Haryanvi Pop",
      "Highlife",
      "Hindi Hip Hop",
      "Hindi Indie",
      "Hindi Pop",
      "Hindustani Classical",
      "Hipdut",
      "Hiplife",
      "Hollands",
      "Indian Fusion",
      "Indie Québécois",
      "Indie Viet",
      "Indonesian Hip Hop",
      "Indonesian Indie Rock",
      "Indonesian Jazz",
      "Indonesian R&B",
      "Indonesian Rock",
      "Irish Traditional",
      "J-Classical",
      "J-Dance",
      "J-Pop",
      "J-R&B",
      "J-Rap",
      "J-Rock",
      "J-Tracks",
      "Japanese VGM",
      "Kagok",
      "Kannada Pop",
      "Karadeniz Turkuleri",
      "Kayokyoku",
      "Khaleeji",
      "Khaleeji Hip-Hop",
      "Khaleeji Saudi",
      "Kizomba",
      "Kollywood",
      "Kompa",
      "Koplo",
      "Kuduro",
      "Kwaito",
      "Laïko",
      "Lofi Viet",
      "Lovers Rock",
      "Luk Thung",
      "M'balax",
      "Mahraganat",
      "Malay Songs",
      "Malayalam Hip Hop",
      "Malayalam Pop",
      "Maloya",
      "Manele",
      "Marathi Pop",
      "Maskandi",
      "Mizrahi",
      "Mizrahit",
      "Mollywood",
      "Mor Lum",
      "Moroccan Chaabi",
      "Moroccan Pop",
      "Moroccan Rap",
      "Motswako",
      "MPB",
      "Mulatós",
      "Murga",
      "Música Nativista",
      "N'dombolo",
      "Native American Music",
      "Ndombolo",
      "Neomelodico",
      "Neue Deutsche Welle",
      "Nigerian Drill",
      "Norsk Rock",
      "Nova MPB",
      "Nusantara Music",
      "NZ Reggae",
      "Outros (Brasil)",
      "Oyun Havasi",
      "Pagode",
      "Pagode Baiano",
      "Parang",
      "Phleng Phuea Chiwit",
      "Piseiro",
      "Polka",
      "Pop Française",
      "Pop Kreatif",
      "Pop Leve",
      "Pop Québécois",
      "Pop Québécoise",
      "Pop Urbaine",
      "Pow Wow",
      "Private School Piano",
      "Punjabi Hip Hop",
      "Punjabi Pop",
      "Qawwali",
      "R&B Québécois",
      "Ragga",
      "Raï",
      "Rap Chrétien",
      "Rap Ivoire",
      "Rap Napoletano",
      "Rap Québécois",
      "Reggae",
      "Reggae En Español",
      "Reggae Pop",
      "Reggae Rock",
      "Reggaeton",
      "Rhumba",
      "Rock Québécois",
      "Rocksteady",
      "Rominimal",
      "Roots Reggae",
      "Rumba (Congolese)",
      "Rumba congolese",
      "Russian Chanson",
      "Samba",
      "Sandalwood",
      "Schlager",
      "Schlagerparty",
      "Schweizer Mundart",
      "Sertanejo",
      "Sertanejo Tradicional",
      "Sertanejo Universitário",
      "Shaaby",
      "Shamstep",
      "Sharqi",
      "Shatta",
      "Sheilat",
      "Shibuya-kei",
      "Singeli",
      "Soca",
      "Soukouss",
      "Southern Thai Music",
      "Swedish Pop",
      "T-Pop",
      "Tamil Dance",
      "Tamil Hip Hop",
      "Tamil Indie",
      "Tamil Pop",
      "Tecnobrega",
      "Telugu Pop",
      "Thai Hip Hop",
      "Thai Indie Pop",
      "Thai Indie Rock",
      "Thai Rock",
      "Thai Trap",
      "Tollywood",
      "Traditional Music",
      "Trap Brasileiro",
      "Trap Funk",
      "Trap Italiana",
      "Trapanele",
      "Tunisian Hip-Hop",
      "Turkce Pop",
      "Turkce Rap",
      "Turkish trap pop",
      "UK Grime",
      "UK R&B",
      "V-Pop",
      "Variété Française",
      "Variété Urbaine",
      "Vietnamese Bolero",
      "Vietnamese Hip Hop",
      "Visor",
      "Visual Kei",
      "Vocaloid",
      "Volksmusik",
      "Zydeco",
    ],
  },
  amazon: {
    Acoustic: ["Acoustic Pop", "Singer-Songwriter"],
    "Children's": [
      "Children's Cartoons",
      "Children's Folk",
      "Classic Disney",
      "Classic Lullabies",
      "Disney",
      "Disney Lullabies",
      "Kindie",
      "Lullabies",
      "Nursery Rhymes",
    ],
    Classical: [
      "Classical: Baroque Period",
      "Classocal Crossover",
      "Classical: Choral Music",
      "Classical: Classical Period",
      "Classical: Medieval Period",
      "Classical: Renaissance Period",
      "Classical: Romantic Period",
      "Contemporary Clasical",
    ],
    Country: [
      "Alt-Country & Americana",
      "Alternative Country Rock",
      "Bluegrass",
      "Classic Country",
      "Classic Folk",
      "Contemporary Country",
      "Contemporary Folk",
      "Country Pop",
      "Country Rock",
      "Cowboy & Western Country",
      "Folk",
      "Modern Folk",
      "Outlaw Country",
      "Red Dirt Country",
      "Texas Roadhouse",
      "Traditional Country",
      "Traditional Folk",
    ],
    "Dance & Electronic": [
      "UK Synth Pop",
      "Ambient",
      "Bassline",
      "Breakbeat",
      "Chill Electronic",
      "Dance Pop",
      "Deep House",
      "Downtempo",
      "Drum & Bass",
      "Dubstep",
      "EDM",
      "Electronica",
      "Future Bass",
      "Future House",
      "House",
      "Nu Disco",
      "Progressive House",
      "Tech House",
      "Techno",
      "Trance",
      "Trip Hop",
      "Tropical House",
      "UK Garage",
    ],
    Holiday: ["Holiday"],
    "Indian Music": [
      "Bhangra",
      "Bollywood",
      "Carnatic Classical",
      "Ghazal",
      "Hindustani Classical",
      "Indian Classical",
      "Indian Folk",
      "Indian Instrumental",
      "Indian Pop",
      "Qawwali",
    ],
    "Indie & Alternative": [
      "Alternative",
      "Britpop",
      "Electronic Rock",
      "Folk Rock",
      "Indie & Lo-Fi",
      "Indie Dance",
      "Indie Folk",
      "Indie Rock",
      "Indie Pop",
      "Lo-Fi Rock",
      "Modern Alternative",
    ],
    Jazz: [
      "Acid Jazz",
      "Avant Garde Jazz",
      "Bebop",
      "Big Band",
      "Contemporary Jazz",
      "Cool Jazz",
      "Free Jazz",
      "Hard Bop",
      "Jazz",
      "Jazz Fusion",
      "Jazz Rock",
      "Latin Jazz",
      "Lounge",
      "New Orleans Jazz",
      "Post-Bop",
      "Smooth Jazz",
      "Soul Jazz",
      "Swing Jazz",
    ],
    "Latin Music": [
      "Bachata",
      "Banda",
      "Bossa Nova",
      "Brazilian",
      "Brazilian Catholic",
      "Brazilian Children's",
      "Brazilian Christian",
      "Brazilian Funk",
      "Brazilian Metal",
      "Brazilian Pop",
      "Brazilian Rap",
      "Brazilian Rock",
      "Brazilian Trap",
      "Champeta",
      "Colombian Popular",
      "Corrido",
      "Cuban Music",
      "Cumbia",
      "Dembow",
      "Forró",
      "Grupera",
      "Hip-Hop Mexicano",
      "Latin Alternative",
      "Latin Christian",
      "Latin Pop",
      "Latin Rap",
      "Latin Rock",
      "Latin Trap",
      "Latin Urban",
      "Latino",
      "Mariachi",
      "Merengue",
      "Mexican",
      "MPB",
      "Norteno",
      "Nova MPB",
      "Pagode",
      "Pisadinha",
      "Rancera",
      "Reggaeton",
      "Regional Mexican",
      "Rock En Espanol",
      "Salsa",
      "Samba",
      "Sertanejo",
      "Sertanejo Raiz",
      "Spanish Hip-Hop",
      "Pop in Spanish",
      "Tejano",
      "Tropical",
      "Vallenato",
    ],
    "New Age": ["New Age"],
    "Non-Music": ["Stand-Up Comedy", "Spoken Word", "Comedy Music"],
    Pop: [
      "Adult Contemporary",
      "Alternative Pop",
      "European Alternative Pop",
      "Cantautorato",
      "Crooner & Easy Listening",
      "Easy Listening",
      "Exotica",
      "Hi-NRG",
      "Hyperpop",
      "Pop",
      "Sophisti-pop",
      "Space Age Pop",
    ],
    "R&B": [
      "Adult Contemporary R&B",
      "Alternative R&B",
      "Classic R&B",
      "Classic Soul",
      "Contemporary R&B",
      "Deep Soul",
      "Detroit Soul",
      "Disco",
      "Funk",
      "Go-Go",
      "Modern R&B",
      "Modern Soul",
      "Neo Soul",
      "Old-School R&B",
      "Soul",
      "Swamp Funk",
    ],
    "Rap & Hip-Hop": [
      "Alternative Hip-Hop",
      "Bounce",
      "Conscious Rap",
      "Contemporary Rap",
      "Crunk",
      "German Rap & Hip-Hop",
      "Drill",
      "East Coast Hip-Hop",
      "Emo Rap",
      "Experimental Hip-Hop",
      "Lo-Fi Hip-Hop",
      "Miami Bass",
      "Modern Hip-Hop",
      "Modern Rap",
      "[D]Classic Hip-Hop",
      "Old Skool Rap",
      "Pop Rap",
      "Rap From France",
      "Rap Italiano",
      "Snap",
      "Southern Rap",
      "Trap Rap",
      "Uk Hip-Hop",
      "West Coast Hip-Hop",
    ],
    "Religious Music": [
      "Christian Alternative",
      "Christian Black Metal",
      "Christian Contemporary",
      "Christian Instrumental",
      "Christian Pop",
      "Christian Rap",
      "Christian Rock",
      "Country Christian",
      "Gospel",
      "Hymns",
      "Modern Gospel",
      "Spiritual",
      "Southern Gospel",
      "Traditional Gospel",
    ],
    Rock: [
      "Adult Album Alternative",
      "Adult Oriented Rock",
      "Alternative Metal",
      "Alternative Rock",
      "Black Metal",
      "Blues Rock",
      "British Blues",
      "British Invasion",
      "Classic Rock",
      "Celtic Punk",
      "Death Metal",
      "German Rock",
      "Dream Pop",
      "Emo Rock",
      "Extreme Metal",
      "Garage Rock",
      "Glam",
      "Glam Metal",
      "Grunge",
      "Hard Rock",
      "Hard Rock & Metal",
      "Hardcore Punk",
      "Rock Italiano",
      "Metal",
      "Metalcore",
      "Pop Punk",
      "Post Punk",
      "Progressive Rock",
      "Psychedelic Rock",
      "Punk",
      "Rock'n'Roll",
      "Rock From France",
      "Rockabilly",
      "Shoegaze",
      "Surf",
      "Texas Blues Rock",
      "Thrash & Speed Metal",
      "Thrash Metal",
      "Yacht Rock",
    ],
    World: [
      "Deutscher Pop",
      "French Pop",
      "Italian Indie Pop",
      "K-pop",
      "Italian Pop",
      "Anime",
      "Japanese City Pop",
      "Enka",
      "Japanese Dance Pop",
      "Japanese Hip-Hop",
      "J-Pop",
      "Japanese R&B",
      "Japanese Rock",
      "Showa-Era Japanese Pop",
      "Video Game",
      "Afropop",
      "Afrobeat",
      "African",
      "African Traditional Music",
      "Arabic",
      "Dancehall",
      "Dub",
      "Neapolitan",
      "Reggae",
      "Sertanejo",
      "Ska",
      "Soca",
      "French Variety",
      "Worldbeat",
      "German Folk Music",
      "Volkstuemlich",
      "New German Folk Music",
      "Blasmusik",
      "Ballermann",
      "Oktoberfest",
      "Karneval",
      "Kölner Karneval",
    ],
  },
  deezer: {
    "Children's": ["Kids"],
    Classical: ["Classical"],
    Country: ["Alt Country", "Americana", "Bluegrass", "Country", "Folk"],
    "Dance & Electronic": [
      "Ambient",
      "Dance & EDM",
      "Electronic",
      "House",
      "Lofi",
      "Techno",
    ],
    "Indie & Alternative": ["Alternative"],
    Jazz: ["Jazz"],
    "Latin Music": ["Forró", "Latin", "Reggaeton", "Samba/Pagode", "Zouk"],
    Pop: ["Hyperpop", "Pop", "Soundtracks"],
    "R&B": ["Soul", "R&B"],
    "Rap & Hip-Hop": ["Old School", "Rap"],
    "Religious Music": ["Christian", "Gospel"],
    Rock: ["Metal", "Rock"],
    World: [
      "Afrobeats",
      "Anime",
      "BR funk",
      "French Chanson",
      "French Music",
      "J-Pop",
      "K-Pop",
      "MPB",
      "Reggae",
      "Schlager",
      "Sertanejo",
    ],
  },
  audiomack: {
    Country: ["Country"],
    "Dance & Electronic": ["Electronic", "Lo-Fi"],
    "Latin Music": ["Latin", "Mexican"],
    Pop: ["Pop"],
    "R&B": ["R&B"],
    "Rap & Hip-Hop": ["Hip-Hop/Rap"],
    "Religious Music": ["Gospel"],
    Rock: ["Rock"],
    World: ["Afrosounds", "Caribbean"],
  },
  TIDAL: {
    "Children's": ["Kids"],
    Classical: ["Classical"],
    Country: ["Country", "Folk/Americana"],
    "Dance & Electronic": ["Dance", "Electronic", "Lo-Fi", "Reggae/Dancehall", "Reggaeton"],
    Holiday: ["Holiday"],
    "Indie & Alternative": ["Indie"],
    Jazz: ["Jazz"],
    "Latin Music": [
      "Bachata",
      "Balada",
      "Cristiana",
      "Cumbia",
      "Flamenco",
      "Guaracha",
      "Latin",
      "Latin Alt",
      "Latin Electronica",
      "Latin Pop",
      "Latin Pop Rock",
      "Latin R&B",
      "Latin Rap",
      "Latin Rock/Indie",
      "Latin Trap",
      "Merengue",
      "Regional MX",
      "Reggaeton",
      "Salsa",
      "Samba",
      "Soca",
      "Tropical",
      "Urbano",
      "Banda",
      "Corrido",
      "Norteño",
      "Mariachi",
      "Corridos Tumbados",
      "Sierreño",
    ],
    "Non-Music": ["Comedy"],
    Pop: ["K-Pop", "Legacy", "Pop", "Soundtrack"],
    "R&B": ["R&B"],
    "Rap & Hip-Hop": ["Hip-Hop"],
    "Religious Music": ["Christian/Gospel"],
    Rock: ["Blues", "Legacy", "Metal", "Rock"],
    World: [
      "African/Afrobeat",
      "Deutschpop",
      "Deutschrap",
      "K-Pop",
      "Mundart",
      "Schlager",
      "Volksmusik",
      "World",
    ],
  },
  soundcloud: {
    "Indie & Alternative": ["Alternative", "Indie", "Alt Rock"],
    Country: ["Country", "Country Rap"],
    "Dance & Electronic": ["Dance/Electronic"],
    World: [
      "Afrobeats",
      "Afropop",
      "Dancehall",
      "J-Pop",
      "K-Pop",
      "Latin",
      "Reggae",
      "World",
    ],
    "Rap & Hip-Hop": ["Hip-Hop/Rap"],
    Pop: ["Pop"],
    "R&B": ["R&B/Soul"],
    Rock: ["Rock", "Metal"],
    Holiday: ["Holiday"],
  },
  youtube: {},
  apple: {
    "Children's": ["Children's Music"],
    Classical: ["Classical", "Instrumental", "Piano", "Violin", "Violin Jazz"],
    Country: ["Alternative Country", "Americana", "Country", "Folk"],
    "Dance & Electronic": ["Ambient", "Electronic", "House"],
    Holiday: ["Holiday"],
    "Indie & Alternative": ["Alternative", "Alternative Country", "Indie Pop", "Indie Rock"],
    Jazz: ["Jazz", "Smooth Jazz"],
    "Latin Music": ["Latin"],
    Pop: ["Indie Pop", "Pop", "Pop Punk", "Pop/Rock", "Singer/Songwriter", "Soundtrack"],
    "R&B": ["Funk", "R&B/Soul"],
    "Rap & Hip-Hop": ["Hip Hop/Rap"],
    Rock: ["Blues", "Indie Rock", "Pop Punk", "Pop/Rock", "Punk", "Rock", "Ska"],
    World: ["World"],
  },
  vevo: {
    Acoustic: ["Other"],
    "Children's": ["Other"],
    Classical: ["Classical", "Other"],
    Country: ["Country", "Other"],
    "Dance & Electronic": ["Dance/EDM", "Dancehall", "Hot AC", "Other"],
    Holiday: ["Christmas", "Other"],
    "Indian Music": ["Other"],
    "Indie & Alternative": ["Alternative", "Indie", "Other"],
    Jazz: ["Jazz", "Other"],
    "Latin Music": ["Latin", "Other"],
    "New Age": ["Other"],
    "Non-Music": ["Other"],
    Pop: ["Pop", "Soundtrack", "Other"],
    "R&B": ["R&B/Soul", "Other"],
    "Rap & Hip-Hop": ["Rap/Hip-Hop", "Other"],
    "Religious Music": ["Christian/Gospel", "Other"],
    Rock: ["Rock", "Other"],
    World: ["Afrobeats", "Brazil", "Reggae", "Other"],
  },
};
